import swal from "sweetalert";
import axiosInstance from "../api";
import { setDynamicSections, setDynamicSectionDetail, setProductList } from "../../reusableSlice";

// ── Shared: Product List (used by offers, etc.) ──────────────────

export const getProductListData = (data) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/products/", { params: data });
    if (response?.data) {
      dispatch(setProductList(response?.data?.response));
    } else {
      dispatch(setProductList([]));
    }
  } catch (err) {
    dispatch(setProductList([]));
  }
};

// ── Dynamic Sections CRUD ───────────────────────────────────────

export const getDynamicSections = (params = {}) => async (dispatch) => {
  try {
    const response = await axiosInstance.get("admin/sections/", { params });
    if (response?.data?.status) {
      const raw = response?.data?.response;
      const data = Array.isArray(raw?.data) ? raw.data : [];
      dispatch(setDynamicSections({ data, pagination: raw?.pagination || null }));
    } else {
      dispatch(setDynamicSections({ data: [], pagination: null }));
    }
  } catch (err) {
    dispatch(setDynamicSections({ data: [], pagination: null }));
  }
};

export const getDynamicSectionDetail = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`admin/sections/${id}`);
    if (response?.data?.status) {
      dispatch(setDynamicSectionDetail(response?.data?.response || null));
    } else {
      dispatch(setDynamicSectionDetail(null));
    }
  } catch (err) {
    dispatch(setDynamicSectionDetail(null));
  }
};

export const createDynamicSection = (data, setLoading, onSuccess) => async () => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("admin/sections/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Section created successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      if (onSuccess) onSuccess(response?.data?.response);
    } else {
      swal({
        text: response?.data?.message || "Failed to create section",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: "Failed to create section",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } finally {
    setLoading(false);
  }
};

export const updateDynamicSection = (data, setLoading, onSuccess) => async () => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("admin/sections/", data);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Section updated successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      if (onSuccess) onSuccess(response?.data?.response);
    } else {
      swal({
        text: response?.data?.message || "Failed to update section",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: "Failed to update section",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } finally {
    setLoading(false);
  }
};

export const deleteDynamicSection = (id, setLoading, onSuccess) => async () => {
  setLoading(true);
  try {
    const response = await axiosInstance.delete(`admin/sections/${id}`);
    if (response?.data?.status) {
      swal({
        text: response?.data?.response?.message || "Section deleted successfully",
        icon: "success",
        button: "Close",
        timer: 1500,
      });
      if (onSuccess) onSuccess();
    } else {
      swal({
        text: response?.data?.message || "Failed to delete section",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
    }
  } catch (err) {
    swal({
      text: "Failed to delete section",
      icon: "error",
      button: "Close",
      timer: 1500,
    });
  } finally {
    setLoading(false);
  }
};
